import { useContext, useEffect, useRef } from "react";
import { WebrtcContext } from "../../modules/Webrtc";
// import Skeleton from "@mui/material/Skeleton";

function VideoContainer({ currentWiidth }: any) {
    const refVideo = useRef<HTMLVideoElement>(null);
    const { streamActive, viewerOptions } = useContext(WebrtcContext);

    useEffect(() => {
        if (!refVideo.current || !streamActive) return;
        refVideo.current.srcObject = streamActive.srcObject;
    }, [streamActive]);

    return (
        <div className="player_video-wrapper">
            <video
                id="player_video"
                onError={() => console.log(" ERRROR VIDEO ")}
                onLoad={() => console.log(" ************************ load ")}
                autoPlay={true}
                ref={refVideo}
            />
        </div>
    );
}

export default VideoContainer;
